import { render, staticRenderFns } from "./company-info-linkman.vue?vue&type=template&id=709db1e4&scoped=true&"
import script from "./company-info-linkman.vue?vue&type=script&lang=js&"
export * from "./company-info-linkman.vue?vue&type=script&lang=js&"
import style0 from "./company-info-linkman.vue?vue&type=style&index=0&id=709db1e4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "709db1e4",
  null
  
)

export default component.exports